import { useEffect } from 'react';

// Opening splash: a blank white page with the brain logo as large as fits, held
// for 5 seconds, then the app proceeds (dashboard when signed in, else the sign-in
// screen). Shown on every fresh page load; in-app navigation doesn't reload, so it
// won't replay mid-work.
export function Splash({ onDone }: { onDone: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDone, 5000);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="splash" onClick={onDone} role="img" aria-label="The AI Solution for 3D">
      <img src="/logo-white.png" alt="The AI Solution for 3D" className="splash-img" />
    </div>
  );
}
